import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";
import RouterSessionManagement from "controllers/router-session-management/index";

/**
 * Login route
 *
 * @extends KernelRoute
 */
class FormRoute extends KernelRoute {

    onFail () {
        return window.location = "#not-found";
    }

    onSuccess (formData) {
        let canPass = "not-acknowledged" === formData.status || "started" === formData.status;
        if (this.parsedParams.token != null) canPass = true;
        if (canPass) {
            System.import("./form").then(View => {
                const view = new View.default({ params: this.parsedParams, formData: formData });
                raf(_ => App.contentRegion.show(view));
            });
        } else {
            window.location = "#completed?referenceNumber=" + this.parsedParams.referenceNumber;
        }
    }

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/form(/)")
    route (params) {
        this.parsedParams = this.parseQueryString(params);
        let manager = new RouterSessionManagement();
        
        manager.obtainForm(this.parsedParams.referenceNumber, this.onSuccess.bind(this), this.onFail.bind(this));
    }
}

export default FormRoute;



// WEBPACK FOOTER //
// ./public/domain/views/form/form.route.js